<template>
    <span v-if="icon" class="section-icon" aria-hidden="true">
        <b-icon :icon="icon" size="is-small" />
    </span>
</template>

<script setup>
/**
 * The badge a layout section wears before its title.
 *
 * It is decoration in the strict sense: the heading beside it already names the
 * section, so the badge is `aria-hidden` — a screen reader that announced
 * "account, Identity and owners" would be reading the same thing twice, once in
 * a vocabulary nobody chose.
 *
 * Renders nothing at all when no icon is set, rather than a placeholder square.
 * A layout built before icons existed keeps exactly the headers it had.
 */
defineProps({
    /** An icon name from the server's catalogue ({@see App\Layout\SectionIcons}). */
    icon: { type: String, default: null }
});
</script>

<style scoped>
.section-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 6px;
    background-color: var(--bulma-primary);
    /* The readable colour *on* primary, which dark mode moves with it — on a
       light theme this is white, on some palettes it is not. */
    color: var(--bulma-primary-invert);
}

/* Bulma paints .icon from the surrounding text colour; inside the badge the
   surrounding colour is the badge's own. */
.section-icon :deep(.icon) {
    color: inherit;
    height: auto;
    width: auto;
}

.section-icon :deep(.mdi::before) {
    font-size: 15px;
    line-height: 1;
}
</style>
